export default {
  inserted: el => {
    let loadImage = null
    el.style.visibility='hidden'
    if (el.nodeName === 'IMG') {
      loadImage = function loadImage() {
        const imageElement = el

        const srcUrl = imageElement.dataset.src
        if (!srcUrl) {
          throw new Error('data-src must have value', imageElement)
        }

        let thumbnailImageSrc = parseToThumbnailUrl(srcUrl, true)
        let actualImageSrc = parseToThumbnailUrl(srcUrl, false)
        
        // Replace the source image src when it is loaded
        if (thumbnailImageSrc !== actualImageSrc) {
          const childImageElement = document.createElement("img")
          childImageElement.style.display = 'none'
          childImageElement.src = actualImageSrc
          imageElement.appendChild(childImageElement)
          
          childImageElement.addEventListener("load", () => {
            imageElement.src = actualImageSrc
          })
          childImageElement.addEventListener("error", () => console.warn('failed to load ' + actualImageSrc))
        }

        imageElement.addEventListener("error", () => console.warn('failed to load ' + thumbnailImageSrc))

        imageElement.src = thumbnailImageSrc
        imageElement.style.visibility = 'visible'
      }
    } else {
      loadImage = function loadImage() {
        const element = el

        const srcUrl = element.dataset.backgroundUrl
          if (!srcUrl) {
            throw new Error('data-background-url must have value', element)
          }

        let thumbnailImageSrc = parseToThumbnailUrl(srcUrl, true)
        let actualImageSrc = parseToThumbnailUrl(srcUrl, false)

        // Replace the source image src when it is loaded
        if (thumbnailImageSrc !== actualImageSrc) {
          const childImageElement = document.createElement("img")
          childImageElement.style.display = 'none'
          childImageElement.src = actualImageSrc
          element.appendChild(childImageElement)
          
          childImageElement.addEventListener("load", () => {
            element.style.backgroundImage = 'url(' + actualImageSrc + ')'
          })
          childImageElement.addEventListener("error", () => console.warn('failed to load ' + actualImageSrc))
        }
      
        element.style.backgroundImage = 'url(' + thumbnailImageSrc + ')'
        element.style.visibility = 'visible'
      }
    }

    function parseToThumbnailUrl(srcUrl, forceThumbnail) {
      const matchesImgur = srcUrl.match(/https:\/\/i.imgur.com\/(\w{7}).(jpg|jpeg)/) // only lazy image for jpg/jpeg format
      let newSrcUrl = srcUrl
      if (matchesImgur) {
        const size = Math.max(window.innerWidth, window.innerHeight)
        let imageSuffix = ''
        if (size <= 320) {
          imageSuffix = 'm'
        } else if (size <= 640) {
          imageSuffix = 'l'
        } else if (size <= 1024 || forceThumbnail) {
          imageSuffix = 'h'
        }
        newSrcUrl = srcUrl.replace(matchesImgur[1], matchesImgur[1] + imageSuffix)
      }
      return newSrcUrl
    }

    function handleIntersect(entries, observer) {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          return;
        } else {
          loadImage()
          observer.unobserve(el)
        }
      })
    }

    function createObserver() {
      const options = {
        root: null,
        threshold: "0",
      };

      const observer = new IntersectionObserver(handleIntersect, options)

      observer.observe(el)
    }

    if (!window["IntersectionObserver"]) {
      loadImage()
    } else {
      createObserver()
    }
  }
};